import { ActionService } from 'dashboard-services/services';

import { settingsMyAccountActions } from 'actions/modules/myAccount';

export default (() => {

  const ON_CHANGE = 'ON_CHANGE_PIPELINE_LIST';
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const getFavoritePipelines = () => (_, getState) => getState().myAccountState.settingsState.favoritePipelines
  
  const addToFavorites = ({ name, groupName, id, tags = [], trigger = undefined, updateSettingsCall }) => dispatch => {
    const favoritePipelines = dispatch(getFavoritePipelines())
    const newFavoritePipelines = favoritePipelines.add({ name, groupName, id, tags, trigger, favorite: true })
    dispatch(settingsMyAccountActions.changeSetting(newFavoritePipelines, 'favoritePipelines'))
    updateSettingsCall({ settings: { favoritePipelines: JSON.stringify(newFavoritePipelines) } })
  }

  const removeFromFavorites = ({ name, groupName, updateSettingsCall }) => dispatch => {
    const favoritePipelines = dispatch(getFavoritePipelines())
    const newFavoritePipelines = favoritePipelines.removeByProps({ name, groupName })
    dispatch(settingsMyAccountActions.changeSetting(newFavoritePipelines, 'favoritePipelines'))
    updateSettingsCall({ settings: { favoritePipelines: JSON.stringify(newFavoritePipelines) } })
  }

  return {
    addToFavorites,
    removeFromFavorites,
    onChange,
    ON_CHANGE
  }
})()